import React, { useEffect, useState } from 'react';
import { Card, Col, Drawer, Input, Row, Table, Tag, Tooltip, message } from "antd";
import { Dialog, Button, PlusIcon, SearchInput, SelectMenu } from "evergreen-ui";
import { MDBAlert, MDBBox, MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import Firebase from "../../Firebase/Firebase";
import FireFetch from "../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import AddLesson from "../../Modals/Lessons/AddLesson";
import { useNavigate, generatePath } from "react-router-dom";
import { writeFile, utils } from "xlsx";
import LessonUploadModal from "../../Modals/UploadModals/LessonUploadModal";
import { getDatabase, ref, update } from "firebase/database";
import ImagePlaceHolder from './placeholder-image.png';
import { useAuth } from '../../AuthContext/AuthContext';
import { getCallable } from '../../Firebase/functionsClient';
const db = getDatabase(Firebase);

const mapLessonToTableRow = (item, index) => ({
	key: item.key || item.id || index + 1,
	id: item.id,
	lessonCode: item.lessonCode,
	lessonName: item.lessonName,
	image: (
		<img
			style={{ width: "2rem", height: "2rem" }}
			src={item.lessonImage || ImagePlaceHolder}
			onError={(e) => {
				e.target.onerror = null;
				e.target.src = ImagePlaceHolder;
			}}
			className="rounded mx-auto d-block"
			alt="lessonImage"
		/>
	),
	language: item.languageName,
	category: item.category,
	subCategory: item.subCategory,
	assignedTo: item.assignedTo,
	theme: item.theme,
	lessonLevel: item.lessonLevel,
	lessonStatus: item.lessonStatus,
	owner: item.owner,
	lessonImage: item.lessonImage,
	_full: item,
});

const filterLessonRows = ({
	lessons = [],
	searchValue = "",
	selectedFilter = null,
	selectedSubFilter = null,
}) => {
	let filteredLessons = lessons;

	if (selectedFilter && selectedFilter !== "All") {
		filteredLessons = filteredLessons.filter(({ category }) =>
			String(category || "").includes(selectedFilter)
		);
	}

	if (selectedSubFilter && selectedSubFilter !== "All") {
		filteredLessons = filteredLessons.filter(({ subCategory }) =>
			String(subCategory || "").toLowerCase().includes(String(selectedSubFilter).toLowerCase())
		);
	}

	const lowerSearch = searchValue?.toLowerCase() || "";
	if (!lowerSearch) {
		return filteredLessons;
	}

	return filteredLessons.filter((item) => {
		const fieldsToSearch = [
			item.lessonName,
			item.lessonStatus,
			item.language,
			item.animationStatus,
			item.category,
			item.subCategory,
			item.theme,
			item.lessonLevel,
			item.owner,
			item.lessonCode,
		];
		return fieldsToSearch.some((field) =>
			String(field || '').toLowerCase().includes(lowerSearch)
		);
	});
};

const Lessons = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateLesson = canAccessModule("LESSONS", "create");
	const canUpdateLesson = canAccessModule("LESSONS", "update");

	const columns = [
		{
			title: 'Image',
			dataIndex: 'image',
			key: 'image',
			responsive: ["sm"]
		},
		{
			title: 'Lesson',
			dataIndex: 'lessonName',
			key: 'lessonName',
			sorter: (a, b) => a.lessonName && a.lessonName.localeCompare(b.lessonName),
			responsive: ["sm"]
		},
		{
			title: 'Lesson Code',
			dataIndex: 'lessonCode',
			key: 'lessonCode',
			sorter: (a, b) => a.lessonCode && a.lessonCode.localeCompare(b.lessonCode),
			responsive: ["sm"]
		},
		{
			title: 'Language',
			dataIndex: 'language',
			key: 'languageName',
			responsive: ["sm"]
		},
		{
			title: 'Theme',
			dataIndex: 'theme',
			key: 'theme',
			render: (theme) => (
				<Tooltip title={theme}>
					<a>{theme}</a>
				</Tooltip>
			),
			sorter: (a, b) => (a.theme || "").localeCompare(b.theme || ""),
			responsive: ["sm"]
		},
		{
			title: 'Lesson Level',
			dataIndex: 'lessonLevel',
			key: 'lessonLevel',
			sorter: (a, b) => a.lessonLevel && a.lessonLevel?.localeCompare(b.lessonLevel),
			responsive: ["sm"]
		},
		{
			title: 'Category',
			dataIndex: 'category',
			key: 'category',
			responsive: ["sm"],
			sorter: (a, b) => a.category && a.category.localeCompare(b.category),
		},
		{
			title: 'Subcategory',
			dataIndex: 'subCategory',
			key: 'subCategory',
			width: '300px',
			sorter: (a, b) => a.subCategory && a.subCategory.localeCompare(b.subCategory),
		},
		{
			title: 'Lesson Status',
			dataIndex: 'lessonStatus',
			key: 'lessonStatus',
			sorter: (a, b) => a.lessonStatus && a.lessonStatus.localeCompare(b.lessonStatus),
			render: (lessonStatus) => (
				<Tag color={lessonStatus === 'published' ? 'green' : 'warning'}>
					{lessonStatus ?? '-'}
				</Tag>
			)
		},
		{
			title: 'Owner',
			dataIndex: 'owner',
			key: 'owner',
		}
	];

	const [searchValue, setSearchValue] = useState();
	const [eventsData, setEventsData] = useState([]);
	const [dataArray, setDataArray] = useState([]);
	const [selectedFilter, setSelectedFilter] = useState(null);
	const [selectedSubFilter, setSelectedSubFilter] = useState(null);
	const [color, setColor] = useState("info");
	const [showAlert, setShowAlert] = useState(false);
	const [message, setMessage] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [categoryArray, setCategoryArray] = useState([]);
	const [subcategories, setSubcategories] = useState([]);
	const [loading, setLoading] = useState(true);
	const [noData, setNoData] = useState(false);
	const [showDeleteAlert, setDeleteAlert] = useState(false);
	const [replaceModal, setReplaceModal] = useState(false);
	const [sArray, setSArray] = useState([]);
	const [showOut, setShowOut] = useState(false);
	const [foundText, setFoundText] = useState("");
	const [excelLesson, setExcelLesson] = useState([]);
	const [exceLoad, setExceLoad] = useState(false);
	const [rawLessons, setRawLessons] = useState([]); // for search & replace / excel
	const navigate = useNavigate();
	const [uploadModal, setUploadModal] = useState(false);
	const listLessons = getCallable("listLessons");

	const handleProceed = (id, object, url) => {
		const safeLesson = JSON.parse(JSON.stringify(object));
		navigate(
			generatePath("/lessons/:id", { id }),
			{ state: { lesson: safeLesson, url } }
		);
	};

	const handleSearch = (searchText) => {
		setSearchValue(searchText);
	};

	const handleFilter = (filterText) => {
		setSelectedFilter(filterText);
	};

	const handleFilterSubs = (filterText) => {
		setSelectedSubFilter(filterText);
	};

	useEffect(() => {
		(async () => {
			try {
				setLoading(true);
				const res = await listLessons({});
				const { lessons = [], categories = [], subcategories: subcats = [] } =
					res.data || {};

				// store for excel + search & replace
				setRawLessons(lessons);
				setExcelLesson(lessons);

				// options for filters
				setCategoryArray(categories);
				setSubcategories(subcats);

				const tempArray = (lessons || []).map((item, index) =>
					mapLessonToTableRow(item, index)
				);

				setDataArray(tempArray);
				setLoading(false);
			} catch (error) {
				console.error("Error fetching lessons from Cloud Function:", error);
				setLoading(false);
			}
		})();
	}, []);

	useEffect(() => {
		const filteredLessons = filterLessonRows({
			lessons: dataArray,
			searchValue,
			selectedFilter,
			selectedSubFilter,
		});
		setEventsData(filteredLessons);
		setNoData(filteredLessons.length === 0 && dataArray.length > 0);
	}, [dataArray, searchValue, selectedFilter, selectedSubFilter]);

	const handleLessonCreated = (lesson) => {
		if (!lesson?.id) {
			return;
		}

		const nextRawLessons = [lesson, ...rawLessons];
		const nextRows = [
			mapLessonToTableRow(lesson, 0),
			...dataArray.map((row, index) => ({ ...row, key: index + 2 })),
		];

		setRawLessons(nextRawLessons);
		setExcelLesson(nextRawLessons);
		setDataArray(nextRows);

	};

	const downloadExcel = (data) => {
		const worksheet = utils.json_to_sheet(data || []);
		const workbook = utils.book_new();
		utils.book_append_sheet(workbook, worksheet, "lessons");
		writeFile(workbook, "Full Lessons.xlsx");
		setExceLoad(false);
	};

	const handleSR = () => {
		const phrase = String(document.getElementById("phrase").value || "").toLowerCase();
		if (phrase.length === 0) {
			alert("The search field cannot be empty");
			return;
		}

		let count = 0;
		const searchArray = [];

		(rawLessons || []).forEach((lesson) => {
			const keys = Object.keys(lesson || {});
			keys.forEach((key) => {
				const value = lesson[key];
				if (
					(typeof value === "string" || value instanceof String) &&
					value.toLowerCase().includes(phrase)
				) {
					searchArray.push({
						key,
						phrase,
						lesson,
					});
					count = count + 1;
				}
			});
		});

		setSArray(searchArray);
		setFoundText("Found phrase in " + count + " places in all Lessons");
		setShowOut(true);
	};

	const handleReplace = () => {
		if (!canUpdateLesson) {
			message.error("You do not have permission to update lessons.");
			return;
		}

		const replace = document.getElementById("replace").value;
		sArray.forEach((item) => {
			const current = String(item.lesson[item.key] || "").toLowerCase();
			item.lesson[item.key] = current.replace(item.phrase, replace);

			const pathId = item.lesson.ID || item.lesson.id;
			update(ref(db, "talmidsdb/lessons/" + pathId), item.lesson)
				.then(() => {
					setColor("success");
					setMessage("lesson phrases successfully updated");
					setShowAlert(true);
					setFoundText("");
					setShowOut(false);
					setTimeout(() => {
						setReplaceModal(false);
						setShowAlert(false);
					}, 2000);
				})
				.catch((error) => {
					setMessage("unable to update lesson phrases due to an error : " + error);
					setColor("danger");
					setShowAlert(true);
					setFoundText("");
					setShowOut(false);
					setTimeout(() => {
						setShowAlert(false);
					}, 2000);
				});
		});
	};

	return (
		<div className="py-4 mx-1 mt-4">
			<Dialog
				isShown={replaceModal}
				title={"Search and Replace"}
				onCloseComplete={() => { setReplaceModal(false); }}
				hasFooter={false}
				maskClosable
			>
				<MDBBox>
					{showAlert ?
						<>
							<MDBAlert color={color} className="my-3" >
								{message}
							</MDBAlert>
						</>
						: null}
					<MDBRow>
						<MDBCol className="px-4">
							<div className="d-flex flex-column ">
								<div className="d-flex flex-column my-2">
									<Text className="mb-1">Enter search phrase</Text>
									<Input
										type="text"
										placeholder="search Phrase"
										className="w-100 mr-4"
										id="phrase"
									/>
									<Button
										appearance="primary"
										className="mt-3"
										onClick={handleSR}
									>
										Search
									</Button>
								</div>
								{showOut ?
									<Text className="mb-1 ">{foundText}</Text>
									: null}
								{sArray.length !== 0 ?
									<div className=" mt-4">
										<Input
											type="text"
											placeholder="Enter phrase to replace with"
											className="mr-4  d-inline"
											id="replace"
										/>
										<Button
											appearance="primary"
											className="mt-3 d-inline"
											onClick={handleReplace}
										>
											Replace
										</Button>
									</div>
									: null}
							</div>
						</MDBCol>
					</MDBRow>
				</MDBBox>
			</Dialog>

			<Drawer
				title="New Lesson"
				width={500}
				maskClosable
				className="font-Nunito"
				placement="right"
				onClose={() => { setShowModal(false); }}
				visible={showModal}
			>
				<AddLesson modal={setShowModal} onLessonCreated={handleLessonCreated} />
			</Drawer>

			<LessonUploadModal showModal={uploadModal} name={"Lesson"} id={"lesson"} />

			<Row gutter={[8, 0]}>
				<Col sm={24}>
					<MDBRow className="w-100">
						<MDBCol className="w-100">
							<Card className="w-100">
								<MDBRow>
									<MDBCol>
										<div className="text-left">
											<div className="d-block">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
													<Text family='Nunito'>
														Lessons
													</Text>
												</h5>
											</div>
										</div>
										<MDBRow className="ml-1">
											<div className="d-flex flex-row">
												<SearchInput
													placeholder="Filter through name, lessonCode and language"
													className="mx-1"
													onChange={e => handleSearch(e.target.value)}
													value={searchValue}
												/>
												<SelectMenu
													title="Choose Lesson"
													width={200}
													hasFilter={false}
													hasTitle={false}
													options={categoryArray}
													selected={selectedFilter}
													closeOnSelect={true}
													onSelect={item => {
														const name = item.name ?? item.label;
														setSelectedFilter(name);
														handleFilter(name);
													}}
												>
													<Button color={"primary"} className="mx-1">
														{selectedFilter || 'Category'}
													</Button>
												</SelectMenu>
												<SelectMenu
													title="Choose Lesson"
													width={200}
													hasFilter={false}
													hasTitle={false}
													options={subcategories}
													selected={selectedSubFilter}
													closeOnSelect={true}
													onSelect={item => {
														const name = item.name ?? item.label;
														setSelectedSubFilter(name);
														handleFilterSubs(name);
													}}
												>
													<Button type={"primary"} className="mx-1">
														{selectedSubFilter || 'SubCategory'}
													</Button>
												</SelectMenu>
												{canUpdateLesson && (
													<Button
														appearance="primary"
														onClick={() => { setReplaceModal(true); }}
														className="d-inline mx-1 float-right"
													>
														S & R
													</Button>
												)}
												<Button
													type="primary"
													className="mx-1"
													onClick={() => {
														FireFetch.exportXL(
															TableExport(document.getElementById("dataTable"), {
																filename: "Lessons",
																exportButtons: false,
																sheetname: "Lessons",
															})
														);
													}}
												>
													Print Table
												</Button>
												<Button
													appearance="primary"
													className="mx-1"
													isLoading={exceLoad}
													onClick={() => {
														setExceLoad(true);
														downloadExcel(excelLesson);
													}}
												>
													Print All
												</Button>
												{canCreateLesson && (
													<>
														<Button
															appearance="primary"
															className="mx-1"
															onClick={() => { setShowModal(true); }}
														>
															New Lesson<PlusIcon />
														</Button>
														<Button
															className="mx-1"
															onClick={() => { setUploadModal(!uploadModal); }}
														>
															Upload
														</Button>
													</>
												)}
											</div>
										</MDBRow>
									</MDBCol>
								</MDBRow>
							</Card>

							{showDeleteAlert ?
								<>
									<MDBAlert color={color} className="my-3 " >
										{message}
									</MDBAlert>
								</>
								: null}

							<Card>
								<Table
									style={{ overflow: "auto" }}
									id={"dataTable"}
									className="custom-table"
									dataSource={eventsData}
									loading={loading}
									pagination={{
										defaultPageSize: 100,
										showSizeChanger: true,
										pageSizeOptions: ['100', '200', '300']
									}}
									columns={columns}
									onRow={(record) => ({
										onClick: () => {
											handleProceed(record.id, record, record.lessonImage);
										},
										style: { cursor: 'pointer' }
									})}
								/>
							</Card>
						</MDBCol>
					</MDBRow>
				</Col>
			</Row>
		</div>
	);
};

export default Lessons;
